import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class ClientesService extends Service{

  protected url: string = this.dominio+"/adm/clientes/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getPaginacao(pagina, limit, relacionamentos = null, filtros = null, fields = null, sort = null, tipo = null){
    let headers = this.getHeaderLogado();
    let urlRelacionamentos = (relacionamentos) ? 'relations='+JSON.stringify(relacionamentos)+'&' : '';
    let urlFiltros = (filtros) ? 'filters='+JSON.stringify(filtros)+'&' : '';
    let urlFields = (fields) ? 'fields='+JSON.stringify(fields)+'&' : '';
    let urlSort = (sort) ? 'sort='+JSON.stringify(sort)+'&' : '';

    let urlTipo = (tipo) ? '&tipo_cliente='+tipo : '';

    return this.http.get(this.url+'?'+ urlRelacionamentos + urlFiltros + urlFields + urlSort +'pages={"page":'+pagina+',"limit":'+limit+'}'+urlTipo, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

  gerarFatura(id){
    let headers = this.getHeaderLogado();

    return this.http.put(this.dominio+'/adm/faturas/faturar-cliente/'+ id, null, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/clientes/clientes.service.ts